<template>
  <div class="container-fluid">
    <div v-if="skin._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ skin.skinName }}</h3>
            <p class="text-center">{{ skin.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div v-if="skin.imageUrl" class="text-center mb-3">
              <img :src="skin.imageUrl" alt="" style="max-width: 100%; max-height: 160px; object-fit: contain;" />
            </div>
            <div class="form-group px-3">
              <label class="form-control-label">تصویر نمایشی (ادمین)</label>
              <input type="file" class="form-control" accept="image/*" @change="imageSelected" />
              <button
                v-if="imageFile"
                type="button"
                class="btn btn-gradient-01 btn-sm mt-2 w-100"
                @click="uploadImage"
              >
                آپلود تصویر
              </button>
            </div>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات مهره</h4>
          </div>
          <div class="widget-body">
            <form id="skinForm" class="form-horizontal">
              <!-- skin english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام مهره</label>
                <div class="col-lg-6">
                  <input type="text" name="skinName" class="form-control" :value="skin.skinName" />
                </div>
              </div>
              <!-- skin cat -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع مهره</label>
                <div class="col-lg-6">
                  <select class="form-control" name="skinCat">
                    <option value="ClubTeam" :selected="skin.skinCat == 'ClubTeam'">مهره باشگاهی</option>
                    <option value="NationalTeam" :selected="skin.skinCat == 'NationalTeam'">مهره ملی</option>
                    <option value="Other" :selected="skin.skinCat == 'Other'">دیگر</option>
                  </select>
                </div>
              </div>

              <!-- skinIndex -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  ایندکس مهره در اپلیکیشن (این مورد باید با اپلیکیشن سازگار باشد، تغیرش ندهید)
                </label>
                <div class="col-lg-6">
                  <input type="number" name="skinIndex" class="form-control" :value="skin.skinIndex" />
                </div>
              </div>
              <!-- skin force -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">قدرت مهره</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" :value="skin.force" />
                </div>
              </div>
              <!-- skin type -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان مهره</label>
                <div class="col-lg-6">
                  <input type="number" name="time" class="form-control" min="1" :value="skin.time" />
                </div>
              </div>
              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت مهره</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="skin.isAvailable">فعال</option>
                    <option value="false" :selected="!skin.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">مهره دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" id="" :checked="skin.isDefault" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/skins">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import skinService from '../../../../services/skin';
export default {
  name: 'skindetail',
  data() {
    return {
      skin: {},
      imageFile: null,
    };
  },
  created() {
    this.getSkin();
  },
  methods: {
    async getSkin() {
      try {
        const skin = await skinService.findSkinById(this.$route.query.id);
        console.log(skin);
        this.skin = skin;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('skinForm');
      const body = {
        _id: this.skin._id,
        skinName: form.skinName.value,
        skinCat: form.skinCat.value,
        skinIndex: form.skinIndex.value,
        formce: form.force.value,
        time: form.time.value,
        isAvailable: form.isAvailable.value == 'true',
        isDefault: form.isDefault.checked,
      };
      try {
        await skinService.updateSkin(body);
        this.getSkin();
      } catch (err) {
        console.log(err);
      }

      console.log(body);
    },

    imageSelected(e) {
      this.imageFile = e.target.files[0] || null;
    },

    async uploadImage() {
      if (!this.imageFile) {
        return window.notif({ isError: true, mssg: 'تصویری انتخاب نشده است' });
      }
      const fileSizeMb = this.imageFile.size / 1024 / 1024;
      if (fileSizeMb > 2) {
        return window.notif({ isError: true, mssg: 'حجم فایل زیاد است (حداکثر ۲ مگابایت)' });
      }
      try {
        await skinService.uploadSkinImage(this.skin._id, this.imageFile);
        this.imageFile = null;
        await this.getSkin();
        window.notif({ isError: false, mssg: 'تصویر آپلود شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی در آپلود تصویر پیش آمده' });
      }
    },
  },
};
</script>
